import { salesTransactionBegin } from 'src/common/helpers/transaction-helper';
import { CustomerDisplayActions } from 'src/common/redux/reducers/customer-display-reducer';
import { CustomerDisplayScreen } from 'src/customer-display/enum/customer-display.enum';
import { ActivityType } from 'src/operation-notify/enum/activities.enum';
import { CustomerDetailsInfo } from 'src/return-services-display/interfaces';
import { LocalStorage } from '../../common/helpers/local-storage';
import { store } from '../../common/redux/configure-store';
import { TransactionActions } from '../../common/redux/reducers/transaction-reducer';
import { CartResponse } from './service/interfaces/cart-response';

export const initiateTransaction = async (data?: InitiateTransactionDto): Promise<CartResponse> => {
  const tillId = LocalStorage.tillId() ?? '';
  const storeId = LocalStorage.storeId();
  const isTraningMode = store.getState().posMode.trainingMode;
  const cartResponse = await salesTransactionBegin(
    storeId,
    tillId,
    isTraningMode,
    data?.typeCode,
    data?.customerDetails,
    data?.tLogId,
    data?.tenderExchangeId,
  );

  store.dispatch(
    TransactionActions.setTransactionState({
      transactionId: cartResponse.cartId ?? '',
      sequenceNumber: cartResponse.sequenceNumber ?? 0,
    }),
  );

  store.dispatch(CustomerDisplayActions.setScreen(CustomerDisplayScreen.SalesScreen));

  return cartResponse;
};

interface InitiateTransactionDto {
  typeCode?: ActivityType;
  customerDetails?: CustomerDetailsInfo;
  tLogId?: string;
  tenderExchangeId?: string;
}
